(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('channelExternal', {
                parent: 'app',
                url: '/transaction/channelExternal',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/channelExternal/channelExternal.html',
                        controller: 'channelExternalController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['transactions']);
                            }],
                            currencies:['currencyService',function(currencyService){
                                return currencyService.getCurrencies();
                            }],
                            regions:['regionService',function(regionService){
                                return regionService.getRegions();
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabPassagesTransaction('channelExternal')
                            }],
                            typeTransaction: [function () {
                                return 'channel';
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            })
    }
})();
